export default {
	type: 'object',
	properties: {
		email: { type: 'string' },
		listName: { type: 'string' },
	},
	required: ['email', 'listName'],
	additionalProperties: false,
}
